export default __webpack_public_path__ + "static/media/Mark-2-Suit-00.b3103bfe.jpg";